import type { JSONContent } from '@tiptap/core'

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value)

const LEGACY_LAYOUT_NODES = new Set(['column', 'twoColumn'])

const normalizeNode = (node: JSONContent, isRoot = false): JSONContent => {
    const content = node.content?.flatMap(child => {
        const normalizedChild = normalizeNode(child)

        // These were structural wrappers in the older two-column extension.
        // StarterKit does not know them, so retain and promote their children.
        return child.type && LEGACY_LAYOUT_NODES.has(child.type)
            ? normalizedChild.content ?? []
            : [normalizedChild]
    })

    return {
        ...node,
        type: isRoot && node.type && LEGACY_LAYOUT_NODES.has(node.type) ? 'doc' : node.type,
        ...(content ? { content } : {}),
    }
}

/**
 * Makes legacy rich-text JSON renderable by StarterKit without changing the
 * persisted value. Localized documents are normalized per locale.
 */
export const normalizeTiptapContent = (value: unknown): unknown => {
    if (!isRecord(value)) return value

    if (typeof value.type === 'string') {
        return normalizeNode(value as JSONContent, true)
    }

    return Object.fromEntries(
        Object.entries(value).map(([key, localizedValue]) => [
            key,
            normalizeTiptapContent(localizedValue),
        ])
    )
}
